import React from 'react';
import styles from './onboarding.module.css';

export default function FinalScreen({ wasPhoneNumProvided }) {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '2.5rem' }}>
                <h1 className={styles.onboardingGreeting}>
                    {wasPhoneNumProvided ? `You're All Set!` : `Okay, you're set for now.`}
                </h1>
                {wasPhoneNumProvided ?
                    <div>
                        <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                            <p className={styles.para} style={{ margin: "0" }}>There's nothing to manage.</p>
                            <p className={styles.para} style={{ margin: "0" }}>Nothing to fix.</p>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <p className={styles.para} style={{ margin: "0" }}>Just notice how you feel.</p>
                            <p className={styles.para} style={{ margin: "0" }}>We'll handle the rest.</p>
                        </div>
                    </div>
                    : <div className={styles.flexDiv} style={{ gap: '2rem' }}>
                        <p className={styles.para}>
                            Turn on reminders anytime in your profile if you find yourself forgetting.
                        </p>
                    </div>
                }
            </div>
        </>
    );
}
